const withinImageSliderEls = document.querySelectorAll('.within-image-slider');
const isLive = document.querySelector('.-live');

if (isLive && withinImageSliderEls.length > 0) {
    let isLarge = window.matchMedia('(min-width: 1200px)').matches;

    window.addEventListener('resize', () => {
        isLarge = window.matchMedia('(max-width: 1200px)').matches;
    });

    withinImageSliderEls.forEach((withinImageSliderEl) => {
        const headlineEl = withinImageSliderEl.querySelector('.within-image-slider__content-headline');

        if (headlineEl) {
            const headlineObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            headlineObserver.unobserve(entry.target);
                            entry.target.classList.add('within-image-slider__content-headline--is-visible');
                        }
                    });
                },
                { threshold: 0.5 }
            );

            headlineObserver.observe(headlineEl);
        }

        const sliderEl = withinImageSliderEl.querySelector('.within-image-slider__content-slider');

        if (sliderEl) {
            window.requestAnimationFrame(() => {
                sliderEl.scroll({ top: 0 });
            });

            const sliderObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            sliderObserver.unobserve(entry.target);
                            entry.target.classList.add('within-image-slider__content-slider--is-visible');

                            const withinImageSliderItems = withinImageSliderEl.querySelectorAll(
                                '.within-image-slider__content-slider-item'
                            );

                            if (sliderEl) {
                                const paddingTop =
                                    Number(window.getComputedStyle(sliderEl).paddingTop.replace(/[a-zA-Z]/g, '')) || 0;

                                for (let i = 0; i < withinImageSliderItems.length; i++) {
                                    const threshold = isLarge ? 2 : 1;
                                    const top =
                                        paddingTop +
                                        withinImageSliderItems[0].scrollHeight * (i - threshold) +
                                        10 * (i - threshold - 1);

                                    setTimeout(() => {
                                        if (i > threshold) {
                                            window.requestAnimationFrame(() => {
                                                sliderEl.scroll({
                                                    behavior: 'smooth',
                                                    top: top,
                                                });
                                            });
                                        }

                                        if (i === withinImageSliderItems.length - 1) {
                                            setTimeout(() => {
                                                window.requestAnimationFrame(() => {
                                                    sliderEl.scroll({
                                                        behavior: 'smooth',
                                                        top: top + withinImageSliderItems[i].scrollHeight,
                                                    });
                                                });
                                            }, 1000);
                                        }
                                    }, 1000 * (i + 1));
                                }
                            }
                        }
                    });
                },
                { threshold: 0.5 }
            );

            sliderObserver.observe(sliderEl);
        }
    });
}
